import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { ERROR_NOT_FOUND, ERROR_SYSTEM } from "../../main/route";
import NotFound from "./NotFound";
import SystemError from "./SystemError";
import ChameleonBrandProvider from "../../common/providers/brand/ChameleonBrandProvider";

export default function ErrorMain() {
  return (
    <ChameleonBrandProvider product="supernova">
      <Switch>
        <Route path={ERROR_NOT_FOUND} component={NotFound} />
        <Route path={ERROR_SYSTEM} component={SystemError} />
        <Redirect to={ERROR_SYSTEM} />
      </Switch>
    </ChameleonBrandProvider>
  );
}
